import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuerySettingService {

   private readonly http = inject(HttpClient);



  addNewQuerySetting(params:any){
        return this.http.post(`${environment.api.host_path}/query-setting`, params);
  }

  getQuerySettingList(pageIndex: number, pageSize: number, sortBy: string, querySettingFilter?: {filename?: string; type?: string}): Observable<any> {
    let params = new HttpParams().set('pageIndex', pageIndex).set('pageSize', pageSize).set('sortBy', sortBy);
    if(querySettingFilter){
      if(querySettingFilter.filename){
        params = params.set('filename', querySettingFilter.filename);
      }
      if(querySettingFilter.type){
        params = params.set('type', querySettingFilter.type);
      }
     }
    return this.http.get<any>(`${environment.api.host_path}/query-setting/list`, { params });
  }

   /**
   * Recupera tutti i query setting a seconda del tipo nel filtro (non paginato)
   */
  getAllQuerySettings(querySettingFilter?: {filename?: string; type?: string}): Observable<any> {
    let params = new HttpParams();
    if(querySettingFilter){
      if(querySettingFilter.filename){
        params = params.set('filename', querySettingFilter.filename);
      }
      if(querySettingFilter.type){
        params = params.set('type', querySettingFilter.type);
      }
     }
    return this.http.get<any>(`${environment.api.host_path}/query-setting/listAll`, { params });
  }


  deleteQuerySetting(id: number){
    return this.http.delete(`${environment.api.host_path}/query-setting/${id}`);
  }

  reloadSearchAnalyzers(): Observable<any> {
    return this.http.post(`${environment.api.host_path}/query-setting/reload-search-analyzers`, {});
  }

  downloadTxt(id: number): Observable<any> {
    return this.http.get(`${environment.api.host_path}/query-setting/${id}/download`, {
      responseType: 'blob'
    });
  }


}
